import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import React from "react";
import { css } from "styled-components";

export interface CookieSettingsStyles {
    linkStyles?: LinkPresentationProps;
}

export const cookieSettingsStyles: CookieSettingsStyles = {
    linkStyles: {
        css: css`
            font-size: 14px;
        `,
        typographyProps: {
            color: "#999 !important",
            css: css`
                &:hover {
                    color: #fff !important;
                }
            `,
        },
    },
};

const CookieSettings = () => {
    const styles = cookieSettingsStyles;
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        window.dispatchEvent(new Event("show-cookie-popup"));
    };

    return (
        <StyledWrapper>
            <Link onClick={handleClick} {...styles.linkStyles}>
                {translate("Cookie Settings")}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CookieSettings,
    definition: {
        group: "Basic",
        displayName: "Cookie Settings",
    },
};

export default widgetModule;
